/* Creado para Imgen con foto carrusel */
const initFlickity = () => {
  const elem = document.querySelector('.carousel-main-wrapper');
  if (elem) {
    if (typeof Flickity !== 'undefined' && elem.flickityData) {
        elem.flickityData.destroy();
    }

    const flkty = new Flickity(elem, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      autoPlay: false,
      prevNextButtons: true,
      pageDots: true,
      draggable: true, 
      percentPosition: true, 
      adaptiveHeight: true
    });

     setTimeout(() => {
        flkty.resize();
    }, 200);
  }
};

if (typeof Flickity === 'undefined') {
  const script = document.createElement('script');
  script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
  script.onload = initFlickity;
  document.head.appendChild(script);
} else {
  initFlickity();
}

document.addEventListener('shopify:section:load', initFlickity);